import { useEffect, useState } from "react"
import { Form, Modal } from "antd"
import CustomButton from "../../../components/CustomButton"
import Notifications from "../../../helpers/Notifications"
import api from "./api"
import actions from "../../actions"
import { useTranslation } from "react-i18next"
import {setFormErrors} from "../../../helpers/formErrors";
import CustomInputNumber from "../../../components/CustomInputNumber"

const ReInterdigitCoefficientChangeForm = ({ visible, setVisible, setRecord, record, changed }) => {
	const [loading, setLoading] = useState(false)

	const {t} = useTranslation(['common', 'valid', 'action'])
	const [form] = Form.useForm()

	const create = params => {
		action(api.create, params, changed, actions.create)
	}

	const update = params => {
		action(api.update, params, changed, actions.update)
	}

	const action = (func, params, sucFunction, sucParams) => {
		setLoading(true)
		func(params)
			.then(res => sucFunction(res, sucParams))
			.catch(err => {
				setFormErrors(err, form)
			})
			.finally(() => setLoading(false))
	}

	useEffect(() => {
		form.resetFields()
		if (record) {
			form.setFieldsValue({
				rank   : record.rank,
				value  : record.value,
			})
		}
	}, [record])

	function handleCancel(){
		form.resetFields()
		setRecord(null)
		setVisible(false)
	}

	const save = () => {
		form.validateFields().then(values => {
			const updateValues = {
				id     : record?.id,
				rank   : values.rank,
				value  : values.value,
			}
			const previousValues = {
				id         : record?.id,
				rank       : record?.rank,
				value      : record?.value,
			}
			if (JSON.stringify(updateValues) === JSON.stringify(previousValues))
				Notifications.errorNotice(t('valid:sameData'), null, 20)
			else
				record ? update(updateValues) : create(updateValues)
		})
	}

	return (
		<Modal
			destroyOnHidden
			footer={[
				<CustomButton
					key="save"
					loading={loading}
					type="green"
					onClick={save}
				>
					{t('action:save')}
				</CustomButton>
			]}
			title={record ? t('action:editRecord') : t('action:addRecord')}
			open={visible}
			width={900}
			onCancel={handleCancel}
		>
			<Form
				form={form}
				labelAlign="left"
				labelCol={{span: 6}}
				name="nsi-form"
				wrapperCol={{span: 17, offset: 1}}
			>
				<Form.Item
					label={t("common:rank")}
					name="rank"
					rules={[
						{
							required   : true,
							message    : t('valid:codeFilledBad'),
						}
					]}
				>
					<CustomInputNumber
					    min={0}
						placeholder={`${t('action:enter')} ${t('common:rank').toLowerCase()}`}
					/>
				</Form.Item>
				<Form.Item
					label={t("common:value")}
					name="value"
					rules={[
						{
							required   : true,
							message    : t('valid:codeFilledBad'),
						}
					]}
				>
					<CustomInputNumber
					    min={0}
						placeholder={`${t('action:enter')} ${t('common:value').toLowerCase()}`}
					/>
				</Form.Item>
			</Form>
		</Modal>
	)
}
export default ReInterdigitCoefficientChangeForm
